import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Storage } from "@ionic/storage";
import { DataService } from "./data.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()

export class XpWorkorderService {

  country = 'NL';

  dummyData = {
    "workorder_type": "3",
    "workorder_nr": "W00000001",
    "reference_nr": "CV-TOOL-XPRNZ",
    "_status": "processing",
    "_valid": {
      "reportCustomerClientPage": 1,
      "reportWorkorderPage": 1,
      "reportSelectUnitPage": 1,
      "reportMeasurementPage": -1,
      "reportChecklistPage": -1,
      "reportRepairsPage": -1
    },
    "_show_all_tabs": true,
    "_has_invoice_customer": 0,
    "_has_external_customer": 0,
    "_selected_units": [
      {
        "unit_brand": "Husqvarna",
        "unit_brand_id": "",
        "unit_model": "Automower",
        "unit_model_id": "",
        "unit_version": "435X AWD NERA",
        "unit_version_id": "",
        "serial_nr": "8569874582636",
        "passport_nr": "NL22M00000870665105",
        "unit_nr": "",
        "year": "2025",
        "service_interval": "24",
        "contract_nr": "",
        "plan_code": "6",
        "time_installation": "",
        "warranty": "",
        "extended_warranty": "",
        "extended_warranty_duration": "",
        "extended_warranty_contact": "",
        "_unit_id": "n1703067555648",
        "list_title": "Husqvarna Automower 435X AWD NERA",
        "list_subtitle": "NL22M00000870665105",
        "status": 1,
        "photos": [],
        "files": [],
        "children": [],
        "unit_model_unit_type": 10,
        "_selected": true,
        "_group": "Grasmaaiers",
        "_group_same_as_prev": false
      }
    ],
    "customers": {
      "client": {
        "terms_agreed":true,
        "time_agreed":1704450533,
        "_requires_action": "2",
        "type": "1",
        "firstname": "T.",
        "lastname": "van der Test",
        "email": "test@vandertest.nl",
        "phone": "0123456789",
        "mobile": "",
        "mobile2": "",
        "preferred_contact_method": "email",
        "street": "Teststraat",
        "number": "1",
        "letter": "",
        "zipcode": "1234 AB",
        "city": "Teststad",
        "country": "NL",
        "older_than_ten_years": "Nee",
        "tax_code": "21%",
        "company": "T. van der Test",
        "notes": "",
        "kvk": "",
        "vat_nr": "",
        "customer_nr": ""
      },
      "invoice": {
        "_requires_action": "2",
        "company": "",
        "notes": "",
        "type": "1",
        "firstname": "",
        "lastname": "",
        "email": "",
        "phone": "",
        "mobile": "",
        "mobile2": "",
        "preferred_contact_method": "email",
        "street": "",
        "number": "",
        "letter": "",
        "zipcode": "",
        "city": "",
        "country": "NL",
        "older_than_ten_years": "",
        "tax_code": "",
        "kvk": "",
        "vat_nr": "",
        "_same_as_client": 1
      },
      "external": {
        "_requires_action": "2",
        "company": "",
        "notes": "",
        "type": "1",
        "firstname": "",
        "lastname": "",
        "email": "",
        "phone": "",
        "mobile": "",
        "mobile2": "",
        "preferred_contact_method": "email",
        "street": "",
        "number": "",
        "letter": "",
        "zipcode": "",
        "city": "",
        "country": "NL",
        "older_than_ten_years": "",
        "tax_code": "",
        "kvk": "",
        "vat_nr": "",
        "_same_as_client": 1
      }
    },
    "location": {
      "_same_as_client": 1,
      "_requires_action": "2",
      "type": "1",
      "firstname": "T.",
      "lastname": "van der Test",
      "email": "test@vandertest.nl",
      "phone": "0123456789",
      "mobile": "",
      "mobile2": "",
      "preferred_contact_method": "email",
      "street": "Teststraat",
      "number": "1",
      "letter": "",
      "zipcode": "1234 AB",
      "city": "Teststad",
      "country": "NL",
      "older_than_ten_years": "Nee",
      "tax_code": "21%",
      "company": "T. van der Test",
      "notes": "",
      "kvk": "",
      "vat_nr": "",
      "customer_nr": "",
      "units": [
        {
          "unit_brand": "ATAG",
          "unit_brand_id": "3",
          "unit_model": "Q42CR",
          "unit_model_id": "",
          "unit_version": "CW6",
          "unit_version_id": "",
          "serial_nr": "8569874582636",
          "passport_nr": "NL22M00000870665105",
          "unit_nr": "",
          "year": "2018",
          "nominal_power": "36.2",
          "openings": "Ja",
          "fuel_type": "Aardgas",
          "cascade": "Nee",
          "unit_type": "HR",
          "exhaust_type": "Concentrisch type C",
          "exhaust_replaced": "",
          "exhaust_location": "Gevel",
          "service_interval": "24",
          "contract_nr": "",
          "plan_code": "6",
          "time_installation": "",
          "time_next_exhaust_check": "",
          "warranty": "",
          "extended_warranty": "",
          "extended_warranty_duration": "",
          "extended_warranty_contact": "",
          "co_detector": "",
          "co_detector_year": "",
          "burner_brand": "",
          "burner_type": "",
          "burner_year": "",
          "burner_serial_nr": "",
          "burner_flow_rate_unit": "",
          "burner_flow_rate_value": "",
          "sprinkler_brand": "",
          "sprinkler_type": "",
          "sprinkler_flow_rate_unit": "",
          "sprinkler_flow_rate_value": "",
          "sprinkler_angle": "",
          "_unit_id": "n1703067555647",
          "list_title": "ATAG Q42CR CW6",
          "list_subtitle": "NL22M00000870665105",
          "status": 1,
          "photos": [],
          "files": [],
          "children": [],
          "unit_model_unit_type": 1,
          "_selected": false,
          "_group": "CV's",
          "_group_same_as_prev": false
        },
        {
          "unit_brand": "Husqvarna",
          "unit_brand_id": "",
          "unit_model": "Automower",
          "unit_model_id": "",
          "unit_version": "435X AWD NERA",
          "unit_version_id": "",
          "serial_nr": "8569874582636",
          "passport_nr": "NL22M00000870665105",
          "unit_nr": "",
          "year": "2025",
          "service_interval": "24",
          "contract_nr": "",
          "plan_code": "6",
          "time_installation": "",
          "warranty": "",
          "extended_warranty": "",
          "extended_warranty_duration": "",
          "extended_warranty_contact": "",
          "_unit_id": "n1703067555648",
          "list_title": "Husqvarna Automower 435X AWD NERA",
          "list_subtitle": "NL22M00000870665105",
          "status": 1,
          "photos": [],
          "files": [],
          "children": [],
          "unit_model_unit_type": 10,
          "_selected": true,
          "_group": "Grasmaaiers",
          "_group_same_as_prev": false
        }
      ]
    },
    "files": [],
    "reports": [
      {
        "type": 100,
        "_unit_id": "n1703067555647",
        "_expanded": false,
        "moment_of_measurement": "Voor het onderhoud",
        "co_ppm": "",
        "co_mg_kwh": "",
        "co_ref_ppm": "",
        "co_ref_end_ppm": "",
        "co2_percent": "",
        "o2_percent": "",
        "o2_intake_percent": "",
        "co_intake_percent": "",
        "co2_intake_percent": "",
        "t_flue_deg_c": "",
        "t_air_deg_c": "",
        "t_delta_deg_c": "",
        "efficiency_hi_percent": "",
        "efficiency_hs_percent": "",
        "p_chimney_mbar": "",
        "p_stat_mbar": "",
        "p_pump_bar": "",
        "p_firebox_pa": "",
        "p_dyn_mbar": "",
        "p_burn_mbar": "",
        "p_control_mbar": "",
        "smoke_index_bacharach": "",
        "lambda": "",
        "t_unit_deg_c": "",
        "mains_voltage": "",
        "warmwater_flow_rate": "",
        "gas_usage_full_load": "",
        "contamination": "",
        "fan_voltage": "",
        "device_id": "",
        "device_sn": "",
        "device_type": "",
        "device_last_service_date": "",
        "reason_first_report_not_possible": "",
        "under_pressure_checked": ""
      }
    ],
    "_current_report": {},
    "checklist": [
      {
        "category_id": "101",
        "layout_code": 1,
        "title": "1. Algemeen",
        "required": true,
        "questions": [
          {
            "question_id": "101",
            "code": "A-02",
            "question": "Voldoet de opstellingsruimte veiligheidseisen",
            "info_title": "Voldoet de opstellingsruimte veiligheidseisen",
            "info_text": "Raadpleeg hiervoor de documentatie van het toestel en de gasvoorschriften.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "102",
            "code": "",
            "question": "Is het toestel op de juiste manier aangesloten?",
            "info_title": "Is het toestel op de juiste manier aangesloten?",
            "info_text": "<ul><li>Is de gaszijdige aansluiting oké?</li><li>Is de waterzijdige aansluiting oké en vrij van lekkage?</li><li>Is de cv-zijdige aansluiting oké en vrij van lekkage?</li><li>Is de rookgaszijdige aansluiting oké en vrij van lekkage?</li></ul>",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "104",
            "code": "A-05",
            "question": "Is de waterdruk in het systeem oké",
            "info_title": "Is de waterdruk in het systeem oké",
            "info_text": "Is de waterdruk in het systeem oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "105",
            "code": "M-03",
            "question": "Is de netspanning 230 Volt +/- 15% en aarde oké",
            "info_title": "Is de netspanning 230 Volt +/- 15% en aarde oké",
            "info_text": "Is de netspanning 230 Volt +/- 15% en aarde oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "107",
            "code": "X-02",
            "question": "Zijn er stalen leidingen in de kruipruimte",
            "info_title": "Zijn er stalen leidingen in de kruipruimte",
            "info_text": "Zijn er stalen leidingen in de kruipruimte",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "N.V.T.",
            "hidden": false
          },
          {
            "question_id": "108",
            "code": "X-06",
            "question": "Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant",
            "info_title": "Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant",
            "info_text": "Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "109",
            "code": "",
            "question": "Toesteldocumentatie bij klant aanwezig",
            "info_title": "Toesteldocumentatie bij klant aanwezig",
            "info_text": "Ontbreekt het onderhoudsvoorschrift, dan geldt een onderhoudsfrequentie van 1 jaar. Ontbreekt het gebruiksvoorschrift, dan dient de klant hierover geïnformeerd te worden.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "102",
        "layout_code": 1,
        "title": "2. Keteldeel",
        "required": true,
        "questions": [
          {
            "question_id": "201",
            "code": "K-01",
            "question": "Warmtewisselaar verbrandingszijdig oké",
            "info_title": "Warmtewisselaar verbrandingszijdig oké",
            "info_text": "Wisselaar en ketel gereinigd en geen sporen van lekkage.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "202",
            "code": "K-02",
            "question": "Verbrandingsruimte oké",
            "info_title": "Verbrandingsruimte oké",
            "info_text": "Afdichting, isolatie in orde bevonden en ruimte gereinigd?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "203",
            "code": "K-03",
            "question": "Trekonderbreker/verbr. gasverzamelkap oké",
            "info_title": "Trekonderbreker/verbr. gasverzamelkap oké",
            "info_text": "Trekonderbreker/verbr. gasverzamelkap oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "N.V.T.",
            "hidden": false
          },
          {
            "question_id": "204",
            "code": "K-04",
            "question": "Isolatie oké",
            "info_title": "Isolatie oké",
            "info_text": "Isolatie oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "205",
            "code": "K-05",
            "question": "Kijkglaasje oké",
            "info_title": "Kijkglaasje oké",
            "info_text": "Pakking in goede staat, glas niet gescheurd en gasdicht.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "206",
            "code": "K-06",
            "question": "CV-pomp oké",
            "info_title": "CV-pomp oké",
            "info_text": "Controleren op lekkage en ongewone geluiden.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "207",
            "code": "K-07",
            "question": "Ontluchting oké",
            "info_title": "Ontluchting oké",
            "info_text": "Controleren op lekkage en functionele werking.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "208",
            "code": "K-08",
            "question": "Condens opvang/sifon/afvoer oké",
            "info_title": "Condens opvang/sifon/afvoer oké",
            "info_text": "Controleer op vervuiling en lekkage en met water vullen voor het toestel in bedrijf wordt genomen.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "209",
            "code": "K-09",
            "question": "Ventilator oké",
            "info_title": "Ventilator oké",
            "info_text": "Gereinigd en controle geluid en lagers.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "210",
            "code": "K-10",
            "question": "Luchtinlaatfilter oké",
            "info_title": "Luchtinlaatfilter oké",
            "info_text": "Reinigen of vervangen.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Nee",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "103",
        "layout_code": 1,
        "title": "3. Branderdeel",
        "required": true,
        "questions": [
          {
            "question_id": "301",
            "code": "",
            "question": "Is het branderdeel oké?",
            "info_title": "Is het branderdeel oké?",
            "info_text": "<ul><li>Vlambeeld oké</li><li>Brander oké</li><li>Waakvlam oké</li><li>Spuitstukken oké</li><li>Mengbuizen oké</li><li>Gasblok/aansluiting gasdichtheid oké</li><li>Branderdeel en ruimte gereinigd?</li></ul>",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "104",
        "layout_code": 1,
        "title": "4. Warm tapwaterdeel",
        "required": true,
        "questions": [
          {
            "question_id": "401",
            "code": "W-01",
            "question": "Inlaatcombinatie oké",
            "info_title": "Inlaatcombinatie oké",
            "info_text": "Controleer op lekkage. Afsluiter op gangbaarheid controleren. Functioneren keerklep controleren.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "402",
            "code": "W-02",
            "question": "Driewegklep Opdrukstift / cartridge oké",
            "info_title": "Driewegklep Opdrukstift / cartridge oké",
            "info_text": "Controleren op lekkage en gangbaarheid.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "404",
            "code": "W-04",
            "question": "Anode oké",
            "info_title": "Anode oké",
            "info_text": "Mate van slijtage beoordelen en vervangen als dit de voorgeschreven grens overschrijd.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "N.V.T.",
            "hidden": false
          },
          {
            "question_id": "405",
            "code": "W-05",
            "question": "Warmtewisselaar / boiler oké",
            "info_title": "Warmtewisselaar / boiler oké",
            "info_text": "Controleer op lekkage en vraag klant naar klachten.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "406",
            "code": "W-06",
            "question": "Isolatie warmtewisselaar oké",
            "info_title": "Isolatie warmtewisselaar oké",
            "info_text": "Isolatie warmtewisselaar oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "407",
            "code": "M-09",
            "question": "Tapdebiet voldoet aan toestel specificatie",
            "info_title": "Tapdebiet voldoet aan toestel specificatie",
            "info_text": "Tapdebiet voldoet aan toestel specificatie",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "408",
            "code": "M-10",
            "question": "Is de instelling van de tapwatertemperatuur oké?",
            "info_title": "Is de instelling van de tapwatertemperatuur oké?",
            "info_text": "Is de instelling van de tapwatertemperatuur oké?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "409",
            "code": "M-20",
            "question": "Stromingsschakelaar oké",
            "info_title": "Stromingsschakelaar oké",
            "info_text": "Stromingsschakelaar oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "N.V.T.",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "105",
        "layout_code": 1,
        "title": "5. Rookgasafvoer",
        "required": true,
        "questions": [
          {
            "question_id": "501",
            "code": "X-03",
            "question": "Rookgasafvoer / verbrandingslucht toevoer gecontroleerd en akkoord bevonden op: Beugelen / verbindingen / lekkage / recirculatie / en algemene staat oké",
            "info_title": "Rookgasafvoer / verbrandingslucht toevoer gecontroleerd en akkoord bevonden op: Beugelen / verbindingen / lekkage / recirculatie / en algemene staat oké",
            "info_text": "Afdichting, isolatie in orde bevonden en ruimte gereinigd?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "502",
            "code": "X-01",
            "question": "Is bij ketel vernieuwing de rookgasafvoer vervangen?",
            "info_title": "Is bij ketel vernieuwing de rookgasafvoer vervangen?",
            "info_text": "Is bij ketel vernieuwing de rookgasafvoer vervangen?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee",
                "hide_questions": [
                  "505"
                ]
              },
              {
                "value": "N.V.T.",
                "hide_questions": [
                  "505"
                ]
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "505",
            "code": "",
            "question": "Datum rookgasafvoer vervangen",
            "info_title": "Datum rookgasafvoer vervangen",
            "info_text": "Datum rookgasafvoer vervangen",
            "answers": [],
            "answer": "",
            "input_value": true,
            "input_placeholder": "DD-MM-JJJJ",
            "value": "11-01-2021",
            "hidden": false
          },
          {
            "question_id": "503",
            "code": "X-04",
            "question": "Is de rookgasafvoer aangesloten op een CLV-systeem?",
            "info_title": "Is de rookgasafvoer aangesloten op een CLV-systeem?",
            "info_text": "Controleer volgens regelgeving.",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee",
                "hide_categories": [
                  "13100"
                ]
              },
              {
                "value": "N.V.T.",
                "hide_categories": [
                  "13100"
                ]
              }
            ],
            "answer": "Nee",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "106",
        "layout_code": 1,
        "title": "6. Regeling en beveiliging",
        "required": true,
        "questions": [
          {
            "question_id": "601",
            "code": "",
            "question": "Ontsteking/vlambeveiliging oké",
            "info_title": "Ontsteking/vlambeveiliging oké",
            "info_text": "<ul><li>Piezo ontsteking waakvlam oké</li><li>Ionisatie electrode oké</li><li>Ontstekings electrode oké</li><li>Gloeiplug oké</li><li>Thermokoppel oké</li><li>Afvaltijd vlambeveiliging [sec] oké</li></ul>",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "605",
            "code": "R-05",
            "question": "Droogkookbeveiliging / Waterdruksensor oké (R-20)",
            "info_title": "Droogkookbeveiliging / Waterdruksensor oké (R-20)",
            "info_text": "Droogkookbeveiliging / Waterdruksensor oké (R-20)",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "606",
            "code": "R-06",
            "question": "Regelthermostaat oké",
            "info_title": "Regelthermostaat oké",
            "info_text": "Regelthermostaat oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "607",
            "code": "R-07",
            "question": "Maximaalthermostaat oké",
            "info_title": "Maximaalthermostaat oké",
            "info_text": "Maximaalthermostaat oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "608",
            "code": "R-08",
            "question": "Bedrading oké",
            "info_title": "Bedrading oké",
            "info_text": "Bedrading oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "611",
            "code": "R-11",
            "question": "Verbr.gas-/lucht-transportbeveiliging oké",
            "info_title": "Verbr.gas-/lucht-transportbeveiliging oké",
            "info_text": "<ul><li>Luchtdruk verschilschakelaar oké</li><li>Verbrandingsgas afvoerbeveiliging (TTB) oké</li></ul>",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "N.V.T.",
            "hidden": false
          },
          {
            "question_id": "613",
            "code": "A-06",
            "question": "Expansievat oké",
            "info_title": "Expansievat oké",
            "info_text": "Expansievat oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          },
          {
            "question_id": "614",
            "code": "A-07",
            "question": "Overdrukventiel oké",
            "info_title": "Overdrukventiel oké",
            "info_text": "Overdrukventiel oké",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              },
              {
                "value": "N.V.T."
              }
            ],
            "answer": "Ja",
            "hidden": false
          }
        ],
        "hidden": false
      },
      {
        "category_id": "13100",
        "layout_code": 1,
        "title": "CLV Systeem",
        "required": true,
        "questions": [
          {
            "question_id": "1310002",
            "code": "",
            "question": "Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?",
            "info_title": "Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?",
            "info_text": "Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              }
            ],
            "answer": "",
            "hidden": false
          },
          {
            "question_id": "1310003",
            "code": "CLV-MJOP",
            "question": "Is er een MJOP aanwezig?",
            "info_title": "Is er een MJOP aanwezig?",
            "info_text": "Is er een MJOP aanwezig? (Meer jaren onderhoud plan)",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              }
            ],
            "answer": "",
            "hidden": false
          },
          {
            "question_id": "1310004",
            "code": "CLV-15Y",
            "question": "Is het CLV systeem ouder dan 15 jaar?",
            "info_title": "Is het CLV systeem ouder dan 15 jaar?",
            "info_text": "Is het CLV systeem ouder dan 15 jaar?",
            "answers": [
              {
                "value": "Ja"
              },
              {
                "value": "Nee"
              }
            ],
            "answer": "",
            "hidden": false
          }
        ],
        "hidden": true
      }
    ],
    "submit": {
      "send_to_customer_client": true,
      "send_to_customer_invoice": false,
      "send_to_customer_external": false,
      "send_to_company": true,
      "send_to_okcv": false,
      "send_to_certification_authority": true,
      "send_to_veka": true,
      "other_email": "",
      "name": "M@kkie Monteur",
      "next_check": null,
      "signature_customer": null,
      "signature_user": "data:image/png;base64,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",
      "extra_company_user_id": ""
    },
    "_skip_checklist": false,
    "minutes_worked": "",
    "is_unit_ok": "",
    "is_unit_safe": "",
    "revisit": "Nee",
    "not_fixed": "",
    "not_fixed_rogafa1": false,
    "not_fixed_rogafa2": false,
    "not_fixed_dyn_druk": false,
    "not_fixed_dichtheidsbeproeving_gasleiding": false,
    "not_fixed_drukveiligheid_gemonteerd": false,
    "not_fixed_expansievat_foutief_gemonteerd": false,
    "bbs_co_te_hoog_opstellingsruimte": false,
    "bbs_co_te_hoog_rookgassen": false,
    "bbs_niet_correct_gemonteerde_rookgasafvoer": false,
    "bbs_niet_correct_gemonteerde_lucht_afvoer": false,
    "bbs_overige_reden": "",
    "bbs_reden_onveiligheid": "",
    "bbs_advies": "",
    "notes": "",
    "repairs": [],
    "parts": [],
    "photos": [],
    "list_title": "[W00000001] T. van der Test  - ATAG Q42CR CW6",
    "list_subtitle": "Teststraat 1, 1234 AB, Teststad - NL22M00000870665105",
    "app_version_number": "UNKNOWN",
    "_id": "n1703064458346",
    "_selected_unit": {
      "unit_brand": "ATAG",
      "unit_brand_id": "3",
      "unit_model": "Q42CR",
      "unit_model_id": "",
      "unit_version": "CW6",
      "unit_version_id": "",
      "serial_nr": "8569874582636",
      "passport_nr": "NL22M00000870665105",
      "unit_nr": "",
      "year": "2018",
      "nominal_power": "36.2",
      "openings": "Ja",
      "fuel_type": "Aardgas",
      "cascade": "Nee",
      "unit_type": "HR",
      "exhaust_type": "Concentrisch type C",
      "exhaust_replaced": "",
      "exhaust_location": "Gevel",
      "service_interval": "24",
      "contract_nr": "",
      "plan_code": "6",
      "time_installation": "",
      "time_next_exhaust_check": "",
      "warranty": "",
      "extended_warranty": "",
      "extended_warranty_duration": "",
      "extended_warranty_contact": "",
      "co_detector": "",
      "co_detector_year": "",
      "burner_brand": "",
      "burner_type": "",
      "burner_year": "",
      "burner_serial_nr": "",
      "burner_flow_rate_unit": "",
      "burner_flow_rate_value": "",
      "sprinkler_brand": "",
      "sprinkler_type": "",
      "sprinkler_flow_rate_unit": "",
      "sprinkler_flow_rate_value": "",
      "sprinkler_angle": "",
      "_unit_id": "n1703067555647",
      "list_title": "ATAG Q42CR CW6",
      "list_subtitle": "NL22M00000870665105",
      "status": 1,
      "photos": [],
      "files": [],
      "children": [],
      "unit_model_unit_type": 1,
      "_selected": true,
      "_group": "CV's",
      "_group_same_as_prev": false
    }
  };

  constructor(
    public api: ApiService,
    public dataService: DataService,
    public translate: TranslateService,
    public storage: Storage
  ) {}

  public setWorkorder(record){
    let data = [record];
    console.log(data);
    return this.setWorkorders(data);
  }

  public setWorkorders(data, skip_existing_workorders?: boolean){
    // Set workorder
    return new Promise((resolve, reject) => {
      this.storage.get('workorders_xp').then((val) => {
        // if local storage already exists
        let workorders = (val ? JSON.parse(val) : []);
        for(let i = 0; i < data.length; i++){
          let record = data[i];
          // Set app_version_number
          record.app_version_number = this.dataService.getAppVersionNumber();
          // Set id
          if(!record._id) record._id = (record.workorder_id ? record.workorder_id : 'n' + new Date().getTime());
          // Add or update
          let found = false;
          for(let j = 0; j < workorders.length; j++){
            if(workorders[j]._id === record._id){
              found = true;
              if(!skip_existing_workorders){
                // Overwrite record
                workorders[j] = record;
              }
            }
          }
          if(!found){
            // Add record
            workorders.push(record);
          }
        }
        this.storage.set('workorders_xp', JSON.stringify(workorders)).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        // if local storage does not exist yet
        let workorders = data;
        this.storage.set('workorders_xp', JSON.stringify(workorders)).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    });
  }

  public getWorkorder(id){
    return new Promise((resolve, reject) => {
      this.storage.get('workorders_xp').then((val) => {
        // if local storage already exists
        let workorders = (val ? JSON.parse(val) : []);
        let found = false;
        for(let j = 0; j < workorders.length; j++){
          if(workorders[j]._id == id){
            found = true;
            resolve(workorders[j]);
          }
        }
        if(!found){
          reject();
        }
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteWorkorder(id){
    return new Promise((resolve, reject) => {
      this.storage.get('workorders_xp').then((val) => {
        let workorders = (val ? JSON.parse(val) : []);
        let found = false;
        for(let j = 0; j < workorders.length; j++){
          if(workorders[j]._id == id){
            found = true;
            workorders.splice(j, 1);
          }
        }
        if(found){
          this.storage.set('workorders_xp', JSON.stringify(workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        } else {
          reject();
        }
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteWorkorders(data){
    return new Promise((resolve, reject) => {
      this.storage.get('workorders_xp').then((val) => {
        let workorders = (val ? JSON.parse(val) : []);
        let changed = false;
        for(let i = 0; i < data.length; i++) {
          let record = data[i];
          for(let j = 0; j < workorders.length; j++){
            if(workorders[j]._id == record._id){
              changed = true;
              workorders.splice(j, 1);
            }
          }
        }
        if(changed){
          this.storage.set('workorders_xp', JSON.stringify(workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        } else {
          reject();
        }
      }).catch(() => {
        reject();
      });
    });
  }

  public getWorkorders(){
    console.log('getWorkorders');
    return new Promise((resolve) => {
      this.storage.get('workorders_xp').then((val) => {
        let workorders = (val ? JSON.parse(val) : []);
        resolve(workorders);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public sendCompletedWorkorders(){
    return new Promise((resolve, reject) => {
      this.storage.get('workorders_xp').then((val) => {
        let workorders = (val ? JSON.parse(val) : []);
        let completed_workorders = [];
        for(let i = 0; i < workorders.length; i++){
          if(workorders[i]._status === 'done'){
            completed_workorders.push(workorders[i]);
          }
        }
        this.deleteWorkorders(completed_workorders).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    });
  }

  public sendSelectedWorkorders(workorders, email){
    return new Promise((resolve, reject) => {
      let completed_workorders = [];
      for(let i = 0; i < workorders.length; i++){
        if(workorders[i]._status === 'done' && workorders[i]._selected){
          completed_workorders.push(workorders[i]);
        }
      }
      if(email){
        this.api.setXpWorkorders(completed_workorders, email).then(() => {
          this.deleteWorkorders(completed_workorders).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        }).catch(() => {
          reject();
        });
      } else {
        setTimeout(() => {
          this.deleteWorkorders(completed_workorders).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        }, 1500);
      }
    });
  }

  public getDummyData(workorder_type){
    let dummyData = JSON.parse(JSON.stringify(this.dummyData));
    dummyData.workorder_type = workorder_type;
    delete dummyData.reports;
    delete dummyData.checklist;
    if(parseInt(workorder_type) != 2){
      delete dummyData.checklist;
    }
    let language = this.translate.currentLang;
    if(this.country === 'BE'){
      delete dummyData.checklist;
      dummyData.customers.client.country = 'BE';
      dummyData.customers.invoice.country = 'BE';
      dummyData.customers.external.country = 'BE';
      dummyData.customers.client.zipcode = '1234';
      dummyData.customers.invoice.zipcode = '1234';
      dummyData.customers.external.zipcode = '1234';
      dummyData.location.country = 'BE';
      dummyData.location.zipcode = '1234';
      dummyData.workorder_nr = 'W00000100';
      dummyData.reference_nr = 'CV-TOOL-XPRNZ_BE';
      dummyData._selected_units[0].unit_model = 'Q38CR';
      dummyData._selected_units[0].unit_version = 'CW5';
      dummyData._selected_units[0].serial_nr = 'P20181803';
      dummyData._selected_units[0].passport_nr = 'BE22M00000870665105';
      dummyData._selected_units[0].list_title = 'ATAG Q38CR CW5';
      dummyData._selected_units[0].list_subtitle = 'BE22M00000870665105';
      dummyData.location.units[0].unit_model = 'Q38CR';
      dummyData.location.units[0].unit_version = 'CW5';
      dummyData.location.units[0].serial_nr = 'P20181803';
      dummyData.location.units[0].passport_nr = 'BE22M00000870665105';
      dummyData.location.units[0].list_title = 'ATAG Q38CR CW5';
      dummyData.location.units[0].list_subtitle = 'BE22M00000870665105';
      dummyData.list_title = '[W00000100] T. van der Test - ATAG Q38CR CW5';
      dummyData.list_subtitle = 'Teststraat 1, 1234, Teststad - BE22M00000870665105';
    }
    if(this.country === 'UY'){
      delete dummyData.checklist;
      dummyData.customers.client.firstname = 'P.';
      dummyData.customers.client.lastname = 'Prueba';
      dummyData.customers.client.company = 'P. Prueba';
      dummyData.customers.client.email = 'prueba@prueba.com';
      dummyData.customers.client.country = 'UY';
      dummyData.customers.client.street = 'Calle de Prueba';
      dummyData.customers.client.city = 'Ciudad de Prueba';
      dummyData.customers.invoice.country = 'UY';
      dummyData.customers.external.country = 'UY';
      dummyData.customers.client.zipcode = '1234';
      dummyData.customers.invoice.zipcode = '1234';
      dummyData.customers.external.zipcode = '1234';
      dummyData.location.country = 'UY';
      dummyData.location.zipcode = '1234';
      dummyData.workorder_nr = 'W00000100';
      dummyData.reference_nr = 'XPRNZ_UY';
      dummyData._selected_units[0].serial_nr = 'P20251124';
      dummyData._selected_units[0].passport_nr = 'UY22M00000870665105';
      dummyData._selected_units[0].list_title = 'Husqvarna Automower 435X AWD NERA';
      dummyData._selected_units[0].list_subtitle = 'UY22M00000870665105';
      dummyData.location.units[0].unit_model = 'Q38CR';
      dummyData.location.units[0].unit_version = 'CW5';
      dummyData.location.units[0].serial_nr = 'P20181803';
      dummyData.location.units[0].passport_nr = 'UY22M00000870665105';
      dummyData.location.units[0].list_title = 'ATAG Q38CR CW5';
      dummyData.location.units[0].list_subtitle = 'UY22M00000870665105';
      dummyData.location.units[1].unit_model = 'Automower';
      dummyData.location.units[1].unit_version = '435X AWD NERA';
      dummyData.location.units[1].serial_nr = 'P20251124';
      dummyData.location.units[1].passport_nr = 'UY22M00000870665105';
      dummyData.location.units[1].list_title = 'Husqvarna Automower 435X AWD NERA';
      dummyData.location.units[1].list_subtitle = 'UY22M00000870665105';
      dummyData.list_title = '[W00000100] P. Prueba - Husqvarna Automower 435X AWD NERA';
      dummyData.list_subtitle = 'Calle de Prueba 1, 1234, Ciudad de Prueba - UY22M00000870665105';
    }
    if(language == 'en'){
      dummyData.customers.client.firstname = 'Mr.';
      dummyData.customers.client.lastname = 'Test';
      dummyData.customers.client.company = 'Mr. Test';
      dummyData.customers.client.email = 'test@test.com';
      dummyData.customers.client.country = 'UY';
      dummyData.customers.client.street = 'Test street';
      dummyData.customers.client.city = 'Test city';
      dummyData.list_title = '[W00000100] Mr. Test - Husqvarna Automower 435X AWD NERA';
      dummyData.list_subtitle = 'Test street 1, 1234, Test city - UY22M00000870665105';
    }
    return dummyData;
  }

  public clearWorkorders(){
    return new Promise((resolve, reject) => {
      this.storage.set('workorders_xp', '[]').then(() => {
        resolve();
      }).catch(() => {
        reject();
      });
    });
  }

  public setDummyData(workorder_type){
    return new Promise((resolve, reject) => {
      let dummyData= this.getDummyData(workorder_type);
      this.clearWorkorders().then(() => {
        this.setWorkorder(dummyData).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      })
    });
  }

  public setCountry(country){
    this.country = country;
  }

  public getCountry(){
    return this.country;
  }

  public getWorkorderTypeString(workorder_type){
    let title = 'Werkorder';
    switch(workorder_type){
      case '1':
        title = '1e inbedrijfstelling';
        break;
      case '2':
        title = 'Onderhoud';
        break;
      case '3':
        title = 'Storing';
        break;
      case '4':
        title = 'Toestel verwijderen';
        break;
      case '5':
        title = 'Aanmelden nieuwe installatie';
        break;
      case '6':
        title = 'Garantiekaart invullen';
        break;
      case '7':
        title = 'Buitenbedrijfstelling';
        break;
    }
    return title;
  }

}



// WEBPACK FOOTER //
// ./src/services/xp-workorder.service.ts